import { COLORS } from '@btime/constants'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import OptionsForm from '../options/OptionsForm'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../../components/pdf/Preview'

const PageContent = ({ type }) => {
  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
      <Grid align="stretch">
        <Col flex={3} flex_mdd={0} scroll height="calc(100vh - 4.3rem)">
          <Preview>
            <PdfDocument type={type} />
          </Preview>
        </Col>

        <Col flex={1}>
          <OptionsForm />
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
